<mat-card class="image-wrapper" [class.is-selected]="isSelected" (click)="this.displayTooltip = true"
          matTooltip="{{ !this.obliqueAvailable ? 'Not able to view on map with this collection' : ''}}">
    @if (isLoading) {
        <div mat-card-image class="loading">
        </div>
    }
    <div>
    <custom-gallery-image [appImageLazyLoad]="image.previewTileURl + this.sizeParameters"
                          [customGalleryImage]="customGalleryImage"
                          [imageContainer]="this.el"
                          [className]="isLoading ? 'loading-image' : 'mat-card-image-default'"
                          (loadEvent)="isLoading = false">
    </custom-gallery-image>
        <div class="image-overlay bottom">
            <span class="orientation-badge">
                {{image.orientation == 'N*' ? 'V' : image.orientation}}
          </span>
        </div>
    </div>
    <mat-card-content class="image-content">
        <div>
            <span class="text-title-medium">{{ image.original_image_name }}</span>
            <div class="copy-image-name">
                <app-copy-clipboard [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="image.original_image_name"></app-copy-clipboard>
            </div>
        </div>
        <div class="small-info-text image-info">
            <span>{{ captureDate }}</span>
            <span class="image-gsd-type">{{ type }}</span>
        </div>
        @if (enableDebugOptions) {
            <span>
              <b>{{ image.orientation }} | {{ image.gsd }} | {{ image.raster_size_width }}
                  /{{ image.raster_size_height }}</b>
            </span>
            <span>
              <b>{{ image.layername }} | {{ image.projectname }} | {{ image.cameratechnology }}
                  | {{ image.utm_zone }} </b>
            </span>
            <span>
              <b>kappa:{{ image.kappa }} | phi:{{ image.phi }} | omega:{{ image.omega }}
                  | focal:{{ image.focal_length }} | z:{{ image.ground_z }}</b>
            </span>
        }
    </mat-card-content>
</mat-card>
